import React from "react"
import cogoToast from "cogo-toast"

const Tab4 = ({tab, setTab, userData, isLoading, submitData}) => {

    /* Submit confirmation */
    const confirmSubmit = _ => {
        if (userData?.tab1?.basic?.username && userData?.tab1?.basic?.email && userData?.tab1?.basic?.phone){
            submitData(userData)
        }
        else {
            cogoToast.error("User Basic information (username, email e.t.c) required");
        }
    }

    return  <form className="form mt-0 mt-lg-10" id="kt_form">
                <div 
                    className="pb-5" 
                    data-wizard-type="step-content" 
                    data-wizard-state={tab === 4 ? "current" : ""}
                >
                    {/* <!--begin::Section--> */}
                    <h4 className="mb-10 font-weight-bold text-dark">Review User Details and Submit</h4>
                    <h6 className="font-weight-bolder mb-3">Basic Details:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Username: <h6 className="d-inline px-3">{userData.tab1?.basic.username}</h6>
                            </div>
                            <div className="col-xl-6">
                                Email: <h6 className="d-inline px-3">{userData.tab1?.basic.email}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                First Name: <h6 className="d-inline px-3">{userData.tab1?.basic.firstName}</h6>
                            </div>
                            <div className="col-xl-6">
                                Last Name: <h6 className="d-inline px-3">{userData.tab1?.basic.lastName}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Middle Name: <h6 className="d-inline px-3">{userData.tab1?.basic.middleName}</h6>
                            </div>
                            <div className="col-xl-6">
                                Phone: <h6 className="d-inline px-3">{userData.tab1?.basic.phone}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Password: <h6 className="d-inline px-3">{userData.tab1?.basic.password}</h6>
                            </div>
                            <div className="col-xl-6">
                            {userData.tab1?.identificationData?.type}: <h6 className="d-inline px-3">{userData.tab1?.identificationData?.value}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Personal Information:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Gender: <h6 className="d-inline px-3">{userData.tab2?.personalData?.gender}</h6>
                            </div>
                            <div className="col-xl-6">
                                Marital Status: <h6 className="d-inline px-3">{userData.tab2?.personalData?.marital}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                            Date of Birth: <h6 className="d-inline px-3">{userData.tab2?.personalData?.birthDay ? [userData.tab2?.personalData.birthDay, userData.tab2?.personalData.birthMonth, userData.tab2?.personalData.birthYear].join("/"): ""}</h6>
                            </div>
                            <div className="col-xl-6">
                                Politically exposed: <h6 className="d-inline px-3">{userData.tab2?.personalData?.politicallyExposedNames}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}


                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Next of Kin:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                First Name: <h6 className="d-inline px-3">{userData.tab2?.trustData?.nextOfKin?.firstName}</h6>
                            </div>
                            <div className="col-xl-6">
                                Last Name: <h6 className="d-inline px-3">{userData.tab2?.trustData?.nextOfKin?.lastName}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Email: <h6 className="d-inline px-3">{userData.tab2?.trustData?.nextOfKin?.email}</h6>
                            </div>
                            <div className="col-xl-6">
                                Phone: <h6 className="d-inline px-3">{userData.tab2?.trustData?.nextOfKin?.phone}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-12">
                                Relationship: <h6 className="d-inline px-3">{userData.tab2?.trustData?.nextOfKin?.relationship}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}


                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Trust Person:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                First Name: <h6 className="d-inline px-3">{userData.tab2?.trustData?.trustInfo?.firstName}</h6>
                            </div>
                            <div className="col-xl-6">
                                Last Name: <h6 className="d-inline px-3">{userData.tab2?.trustData?.trustInfo?.lastName}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Email: <h6 className="d-inline px-3">{userData.tab2?.trustData?.trustInfo?.email}</h6>
                            </div>
                            <div className="col-xl-6">
                                Phone: <h6 className="d-inline px-3">{userData.tab2?.trustData?.trustInfo?.phone}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}


                    
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Address Details:</h6>
                    <div className="text-dark-50 line-height-lg">
                        <div>
                            Address Line 1: <h6 className="d-inline px-3">{userData.tab2?.addressData?.street1}</h6>
                        </div>
                        <div>
                            Address Line 2: <h6 className="d-inline px-3">{userData.tab2?.addressData?.street2}</h6>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Postcode: <h6 className="d-inline px-3">{userData.tab2?.addressData?.postalCode}</h6>
                            </div>
                            <div className="col-xl-6">
                                City: <h6 className="d-inline px-3">{userData.tab2?.addressData?.city}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                State / Province: <h6 className="d-inline px-3">{userData.tab2?.addressData?.province}</h6>
                            </div>
                            <div className="col-xl-6">
                                Country: <h6 className="d-inline px-3">{userData.tab2?.addressData?.country}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Employment Details:</h6>
                    <div className="text-dark-50 line-height-lg">
                        <div>
                            Employment status: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.status}</h6>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Company name: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.company}</h6>
                            </div>
                            <div className="col-xl-6">
                                Type of employment: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.type}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Position: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.position}</h6>
                            </div>
                            <div className="col-xl-6">
                                Company Address: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.address}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Zip / Postcode: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.zip}</h6>
                            </div>
                            <div className="col-xl-6">
                                City: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.city}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                State / Province: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.state}</h6>
                            </div>
                            <div className="col-xl-6">
                                Country: <h6 className="d-inline px-3">{userData.tab3?.employmentData?.country}</h6>
                            </div>
                        </div>

                    </div>
                    {/* <!--end::Section--> */}

                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Investment Profile:</h6>
                    <div className="text-dark-50 line-height-lg">
                        <div>
                            Approximate annual income (USD): <h6 className="d-inline px-3">{userData.tab3?.investmentData?.annualIncome}</h6>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Liquid net worth (USD): <h6 className="d-inline px-3">{userData.tab3?.investmentData?.networthLiquid}</h6>
                            </div>
                            <div className="col-xl-6">
                                Total net worth (USD): <h6 className="d-inline px-3">{userData.tab3?.investmentData?.networthTotal}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Investment objectives: <h6 className="d-inline px-3">{userData.tab3?.investmentData?.investmentObjectives}</h6>
                            </div>
                            <div className="col-xl-6">
                                Investment experience: <h6 className="d-inline px-3">{userData.tab3?.investmentData?.investmentExperience}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Risk tolerance: <h6 className="d-inline px-3">{userData.tab3?.investmentData?.riskTolerance}</h6>
                            </div>
                            <div className="col-xl-6">
                                User's tax rate: <h6 className="d-inline px-3">{userData.tab3?.investmentData?.taxRate}</h6>
                            </div>
                        </div>
                    </div>
                    {/* <!--end::Section--> */}

                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Compliance & AML:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Funding sources: <h6 className="d-inline px-3">{userData.tab3?.complianceData?.fundingSources?.join(", ")}</h6>
                            </div>
                            <div className="col-xl-6">
                                Expected transfers: <h6 className="d-inline px-3">{userData.tab3?.complianceData?.transferFrequencyPerMonth}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Expected annual transfer: <h6 className="d-inline px-3">{userData.tab3?.complianceData?.transferTotalExpected}</h6>
                            </div>
                            <div className="col-xl-6">
                                Past 12 months: <h6 className="d-inline px-3">{userData.tab3?.complianceData?.investmentHistory12M}</h6>
                            </div>
                        </div>
                    </div>
                    {/* <!--end::Section--> */}
                    

                    {/* <!--begin: Wizard Actions--> */}
                    <div className="d-flex justify-content-between border-top mt-5 pt-10">
                        <div className="mr-2">
                            <button
                                onClick={_ => setTab(3)} 
                                type="button" 
                                className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4">Previous</button>
                        </div>
                        <div>
                            <button 
                                type="button" 
                                onClick={confirmSubmit}
                                disabled={isLoading}
                                className="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                            >
                                
                                {
                                    isLoading ?
                                        <div className="spinner-border spinner-border-sm mx-5 text-white" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    :
                                        "Submit"
                                }
                            </button>
                        </div>
                    </div>
                    {/* <!--end: Wizard Actions--> */}
                </div>
            </form>
}

export default Tab4;